document.documentElement.classList.remove('no-js');

const CART_FALLBACK_IMAGE =
  'https://syncere-3.myshopify.com/cdn/shop/files/pexels-cottonbro-3993449.jpg?v=1775219365&width=600';
const FREE_SHIPPING_THRESHOLD = 99900;

const SELECTORS = {
  ajaxProductForm: '[data-ajax-product-form]',
  ajaxSubmit: '[data-ajax-submit]',
  cartClose: '[data-cart-close], [data-syncere-cart-close]',
  cartCount: '[data-cart-count], [data-syncere-cart-count]',
  cartDrawer: '[data-syncere-cart-drawer], [data-cart-drawer]',
  cartDrawerBody: '[data-cart-drawer-body], [data-syncere-cart-items]',
  cartLine: '[data-cart-line]',
  cartNote: '[data-cart-note]',
  cartOpen: '[data-open-cart], [data-syncere-cart-trigger]',
  cartQuantityButton: '[data-cart-quantity-change]',
  cartQuantityInput: '[data-cart-quantity-input]',
  cartRemove: '[data-cart-remove]',
  cartSubtotal: '[data-cart-subtotal], [data-syncere-cart-total]',
  mobileDrawer: '[data-mobile-drawer]',
  mobileNavToggle: '[data-mobile-nav-toggle]',
  quantityWrapper: '[data-quantity-wrapper]',
  reveal: '.reveal',
  siteHeader: '.site-header'
};

const formatMoney = (cents) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format((cents || 0) / 100);

const escapeHtml = (value) =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const getCartDrawer = () => document.querySelector(SELECTORS.cartDrawer);
const getCartDrawerBody = () => document.querySelector(SELECTORS.cartDrawerBody);
const getCartSubtotal = () => document.querySelector(SELECTORS.cartSubtotal);
const getCartNote = () => document.querySelector(SELECTORS.cartNote);

const getCartCountTargets = () =>
  Array.from(document.querySelectorAll(SELECTORS.cartCount)).filter(
    (target) => !target.matches('a, button, svg, path, [data-open-cart], [data-syncere-cart-trigger]')
  );

const updateCartCount = (count) => {
  const safeCount = count || 0;

  getCartCountTargets().forEach((target) => {
    target.textContent = `(${safeCount})`;
    target.setAttribute('aria-label', `${safeCount} item${safeCount === 1 ? '' : 's'} in cart`);
  });

  document.querySelectorAll(SELECTORS.cartOpen).forEach((trigger) => {
    trigger.setAttribute('aria-label', `Cart, ${safeCount} item${safeCount === 1 ? '' : 's'}`);
  });
};

const openCartDrawer = () => {
  const cartDrawer = getCartDrawer();
  if (!cartDrawer) return false;

  closeCompetingCartDrawers(cartDrawer);
  const uiRoot = cartDrawer.closest('#syncere-ui-root');
  const backdrop = uiRoot ? uiRoot.querySelector('[data-syncere-backdrop]') : null;
  if (backdrop) backdrop.classList.add('is-open');
  cartDrawer.classList.add('is-open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-open');
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  return true;
};

const closeCartDrawer = () => {
  const cartDrawer = getCartDrawer();
  if (!cartDrawer) return;

  const uiRoot = cartDrawer.closest('#syncere-ui-root');
  const backdrop = uiRoot ? uiRoot.querySelector('[data-syncere-backdrop]') : null;
  const searchDrawer = uiRoot ? uiRoot.querySelector('[data-syncere-search-drawer]') : null;

  cartDrawer.classList.remove('is-open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  if (backdrop && (!searchDrawer || !searchDrawer.classList.contains('is-open'))) {
    backdrop.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }
  document.body.classList.remove('cart-open');
};

const closeCompetingCartDrawers = (activeDrawer) => {
  document
    .querySelectorAll('cart-drawer, cart-notification, #CartDrawer, .cart-notification, .drawer, [data-cart-notification]')
    .forEach((drawer) => {
      if (drawer === activeDrawer || activeDrawer.contains(drawer)) return;

      drawer.classList.remove('active', 'animate', 'is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (typeof drawer.close === 'function') drawer.close();
    });
};

const getCartImageUrl = (item) => {
  if (item.image) return item.image;
  if (item.featured_image && item.featured_image.url) return item.featured_image.url;
  if (item.featured_image && item.featured_image.src) return item.featured_image.src;
  return CART_FALLBACK_IMAGE;
};

const renderSyncereCartItems = (cart, cartItems) => {
  const emptyTarget = document.querySelector('[data-syncere-cart-empty]');

  if (!cart.items || !cart.items.length) {
    cartItems.innerHTML = '';
    if (emptyTarget) {
      emptyTarget.style.display = 'block';
      emptyTarget.textContent = 'Your ritual is still empty.';
    }
    return;
  }

  if (emptyTarget) emptyTarget.style.display = 'none';

  cartItems.innerHTML = cart.items
    .map((item, index) => {
      const variantTitle =
        item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="syncere-cart-item-variant">${escapeHtml(item.variant_title)}</div>`
          : '';
      const comparePrice =
        item.original_line_price && item.original_line_price > item.final_line_price
          ? `<span class="syncere-cart-compare">${formatMoney(item.original_line_price)}</span>`
          : '';

      return `
        <div class="syncere-cart-item" data-line="${index + 1}">
          <div class="syncere-cart-thumb">
            <img src="${getCartImageUrl(item)}" alt="${escapeHtml(item.product_title)}" width="600" height="900" loading="lazy">
          </div>
          <div class="syncere-cart-info">
            <div class="syncere-cart-item-top">
              <a class="syncere-cart-item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
              <div class="syncere-cart-price">
                ${formatMoney(item.final_line_price)}
                ${comparePrice}
              </div>
            </div>
            ${variantTitle}
            <div class="syncere-cart-row">
              <div class="syncere-qty">
                <button type="button" data-qty-minus aria-label="Decrease quantity">-</button>
                <input type="text" value="${item.quantity}" inputmode="numeric" data-qty-input aria-label="Quantity">
                <button type="button" data-qty-plus aria-label="Increase quantity">+</button>
              </div>
              <button class="syncere-cart-remove" type="button" data-qty-remove>Remove</button>
            </div>
          </div>
        </div>
      `;
    })
    .join('');
};

const renderCartItems = (cart) => {
  const cartDrawerBody = getCartDrawerBody();
  if (!cartDrawerBody) return;

  if (cartDrawerBody.matches('[data-syncere-cart-items]')) {
    renderSyncereCartItems(cart, cartDrawerBody);
    return;
  }

  if (!cart.items || !cart.items.length) {
    cartDrawerBody.innerHTML = `
      <div class="cart-drawer__empty">
        <p class="eyebrow">Your ritual is empty</p>
        <h3>Begin with scalp-first care.</h3>
        <p class="section-copy">Add a Syncere ritual to keep it close while you continue browsing.</p>
        <a class="button" href="/collections/all">Shop all products</a>
      </div>
    `;
    return;
  }

  const itemsMarkup = cart.items
    .map((item, index) => {
      const variantTitle =
        item.variant_title && item.variant_title !== 'Default Title'
          ? item.variant_title
          : 'Syncere ritual';

      return `
        <article class="cart-drawer__item" data-cart-line="${index + 1}">
          <a class="cart-drawer__item-image" href="${item.url}">
            <img src="${getCartImageUrl(item)}" alt="${escapeHtml(item.product_title)}" width="600" height="900" loading="lazy">
          </a>
          <div class="cart-drawer__item-details">
            <div>
              <a class="cart-drawer__item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
              <p class="cart-drawer__item-meta">${escapeHtml(variantTitle)}</p>
            </div>
            <div class="cart-drawer__item-row">
              <div class="cart-drawer__qty" data-cart-quantity>
                <button type="button" data-cart-quantity-change="decrease" aria-label="Decrease quantity">-</button>
                <input type="number" min="0" value="${item.quantity}" aria-label="Quantity for ${escapeHtml(item.product_title)}" data-cart-quantity-input>
                <button type="button" data-cart-quantity-change="increase" aria-label="Increase quantity">+</button>
              </div>
              <strong>${formatMoney(item.final_line_price)}</strong>
            </div>
            <button class="cart-drawer__remove" type="button" data-cart-remove>Remove</button>
          </div>
        </article>
      `;
    })
    .join('');

  cartDrawerBody.innerHTML = `<div class="cart-drawer__items">${itemsMarkup}</div>`;
};

const updateCartUi = (cart) => {
  renderCartItems(cart);

  const cartSubtotal = getCartSubtotal();
  const cartNote = getCartNote();
  const countLabel = document.querySelector('[data-syncere-cart-count-label]');
  const checkoutTotal = document.querySelector('[data-syncere-cart-checkout-total]');
  const progressCopy = document.querySelector('[data-syncere-cart-progress-copy]');
  const progressFill = document.querySelector('[data-syncere-cart-progress-fill]');

  if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
  if (checkoutTotal) checkoutTotal.textContent = formatMoney(cart.total_price);
  if (cartNote) {
    cartNote.textContent = `${cart.item_count || 0} item${cart.item_count === 1 ? '' : 's'} in your ritual bag`;
  }
  if (countLabel) {
    countLabel.textContent = `${cart.item_count || 0} item${cart.item_count === 1 ? '' : 's'}`;
  }

  if (progressCopy && progressFill) {
    const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - (cart.total_price || 0));
    const progress = Math.min(100, Math.round(((cart.total_price || 0) / FREE_SHIPPING_THRESHOLD) * 100));

    progressFill.style.width = `${progress}%`;
    progressCopy.textContent = remaining > 0
      ? `Add ${formatMoney(remaining)} more for complimentary shipping.`
      : 'You are eligible for complimentary shipping.';
  }

  updateCartCount(cart.item_count);
};

const fetchCart = async () => {
  const response = await fetch('/cart.js', {
    headers: {
      Accept: 'application/json'
    }
  });

  if (!response.ok) throw new Error('Unable to fetch cart');
  return response.json();
};

const refreshCart = async (openAfterLoad = false) => {
  try {
    const cart = await fetchCart();
    updateCartUi(cart);
    if (openAfterLoad && !openCartDrawer()) window.location.href = '/cart';
    return cart;
  } catch (error) {
    console.error('Unable to refresh cart', error);
    if (openAfterLoad) window.location.href = '/cart';
    return null;
  }
};

const changeCartLine = async (line, quantity) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ line, quantity })
  });

  if (!response.ok) throw new Error('Unable to update cart');

  const cart = await response.json();
  updateCartUi(cart);
};

const initHeader = () => {
  const header = document.querySelector(SELECTORS.siteHeader);
  const drawerToggle = document.querySelector(SELECTORS.mobileNavToggle);
  const drawer = document.querySelector(SELECTORS.mobileDrawer);

  if (header) {
    const syncHeaderState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };

    syncHeaderState();
    window.addEventListener('scroll', syncHeaderState, { passive: true });
  }

  if (drawerToggle && drawer) {
    drawerToggle.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      drawerToggle.setAttribute('aria-expanded', String(open));
    });
  }
};

const initCartDrawer = () => {
  document.addEventListener(
    'click',
    (event) => {
      const openTrigger = event.target.closest(SELECTORS.cartOpen);
      if (openTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        refreshCart(true);
        return;
      }

      const closeTrigger = event.target.closest(SELECTORS.cartClose);
      if (closeTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeCartDrawer();
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCartDrawer();
  });

  document.addEventListener('click', async (event) => {
    const lineItem = event.target.closest(`${SELECTORS.cartLine}, [data-line]`);
    if (!lineItem) return;
    if (lineItem.hasAttribute('data-line')) return;

    const quantityButton = event.target.closest(`${SELECTORS.cartQuantityButton}, [data-qty-minus], [data-qty-plus]`);
    const removeButton = event.target.closest(SELECTORS.cartRemove);
    if (!quantityButton && !removeButton) return;

    const input = lineItem.querySelector(`${SELECTORS.cartQuantityInput}, [data-qty-input]`);
    const currentValue = Math.max(0, Number(input ? input.value : 0));
    const line = Number(lineItem.getAttribute('data-cart-line') || lineItem.getAttribute('data-line'));

    event.preventDefault();

    try {
      if (removeButton) {
        await changeCartLine(line, 0);
        return;
      }

      const direction = quantityButton.getAttribute('data-cart-quantity-change');
      const isIncrease = direction === 'increase' || quantityButton.hasAttribute('data-qty-plus');
      const nextValue = isIncrease ? currentValue + 1 : Math.max(0, currentValue - 1);
      await changeCartLine(line, nextValue);
    } catch (error) {
      console.error(error);
    }
  });

  document.addEventListener('change', async (event) => {
    const input = event.target.closest(`${SELECTORS.cartQuantityInput}, [data-qty-input]`);
    if (!input) return;

    const lineItem = input.closest(`${SELECTORS.cartLine}, [data-line]`);
    if (!lineItem) return;
    if (lineItem.hasAttribute('data-line')) return;

    try {
      await changeCartLine(
        Number(lineItem.getAttribute('data-cart-line') || lineItem.getAttribute('data-line')),
        Math.max(0, Number(input.value || 0))
      );
    } catch (error) {
      console.error(error);
    }
  });
};

const initAjaxProductForms = () => {
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(SELECTORS.ajaxProductForm);
    if (!form) return;

    if (event.submitter && !event.submitter.matches(SELECTORS.ajaxSubmit)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitButton = event.submitter || form.querySelector('button[type="submit"]');
    const originalText = submitButton ? submitButton.textContent : '';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Add to cart failed');

      if (submitButton) submitButton.textContent = 'Added';
      await refreshCart(true);
    } catch (error) {
      console.error(error);
      window.location.href = '/cart';
    } finally {
      window.setTimeout(() => {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }
      }, 600);
    }
  }, true);
};

const initQuantityControls = () => {
  document.addEventListener('click', (event) => {
    const wrapper = event.target.closest(SELECTORS.quantityWrapper);
    if (!wrapper) return;

    const button = event.target.closest('button');
    const input = wrapper.querySelector('input');
    if (!button || !input) return;

    event.preventDefault();

    const direction = button.getAttribute('data-quantity-change');
    const currentValue = Number(input.value || 1);
    input.value = direction === 'increase' ? currentValue + 1 : Math.max(1, currentValue - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
};

const initRevealAnimations = () => {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTORS.reveal).forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.16 }
  );

  document.querySelectorAll(SELECTORS.reveal).forEach((element) => {
    revealObserver.observe(element);
  });
};

const initSyncereCursor = () => {
  if (window.__syncereCursorInitialized) return true;
  if (!window.matchMedia('(pointer: fine)').matches) return true;

  const cursorDot = document.getElementById('syncere-cursor-dot');
  const cursorRing = document.getElementById('syncere-cursor-ring');
  if (!cursorDot || !cursorRing) return false;

  window.__syncereCursorInitialized = true;

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let ringX = mouseX;
  let ringY = mouseY;

  const moveDot = () => {
    cursorDot.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0) translate3d(-50%, -50%, 0)`;
  };

  const animateRing = () => {
    ringX += (mouseX - ringX) * 0.18;
    ringY += (mouseY - ringY) * 0.18;
    cursorRing.style.transform = `translate3d(${ringX}px, ${ringY}px, 0) translate3d(-50%, -50%, 0)`;
    window.requestAnimationFrame(animateRing);
  };

  window.addEventListener(
    'mousemove',
    (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;
      document.body.classList.add('syncere-cursor-active');
      moveDot();
    },
    { passive: true }
  );

  window.addEventListener('mouseleave', () => {
    document.body.classList.remove('syncere-cursor-active', 'syncere-cursor-hover');
  });

  window.addEventListener('mouseenter', () => {
    document.body.classList.add('syncere-cursor-active');
  });

  document.addEventListener(
    'mouseover',
    (event) => {
      if (event.target.closest('a, button, summary, label, input, select, textarea, [role="button"]')) {
        document.body.classList.add('syncere-cursor-hover');
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'mouseout',
    (event) => {
      if (event.target.closest('a, button, summary, label, input, select, textarea, [role="button"]')) {
        document.body.classList.remove('syncere-cursor-hover');
      }
    },
    { passive: true }
  );

  moveDot();
  animateRing();
  return true;
};

const scheduleCursorInit = () => {
  if (initSyncereCursor()) return;

  [100, 400, 1000, 2000].forEach((delay) => {
    window.setTimeout(initSyncereCursor, delay);
  });
};

const initTheme = () => {
  initHeader();
  initCartDrawer();
  initAjaxProductForms();
  initQuantityControls();
  initRevealAnimations();
  scheduleCursorInit();
  refreshCart(false);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTheme);
} else {
  initTheme();
}

window.addEventListener('pageshow', () => {
  refreshCart(false);
});
